import { ApiResponse, ValidationError } from '../types/Response'

/**
 * @description Constructs a log message from the response object, that can be used to log or throw errors.
 * */
export const constructLogMessageFromResponseValidationErrors = (response: ApiResponse) => {
    const separator = '\n• '
    const validationErrorMessages = response?.validationErrors
        ?.map((validation: ValidationError) => {
            return validation?.errorMessage
        })
        .join(separator)
    const message = `${response?.errorCode} -> ${response?.message}\n${separator}${
        validationErrorMessages ?? 'no validation messages'
    }`
    return message
}
